function eraseCookie(name) {
    document.cookie = name+'=; path=/; domain='+'.'+window.location.host+'; expires=' + new Date(0).toUTCString();
    document.cookie = name+'=; path=/; domain='+'.'+window.location.host.replace('www.', '')+'; expires=' + new Date(0).toUTCString();
}

function removeCookiePro() {
    eraseCookie('OptanonAlertBoxClosed');
    eraseCookie('OptanonConsent');
    eraseCookie('intercom-id-r6ltm8ar');
    eraseCookie('__cfduid');
    eraseCookie('sty-cookie-clicked');
}

Cm.cookie = {
    init: function() {
        $('body').on('click', '[data-trigger="reset-cookie"]', function(e) {
            var $alertBox = $(this).closest('body').find('.optanon-alert-box-wrapper');
            e.preventDefault();

            if( Cm.cookie.getCookie('OptanonConsent') == null) return false;

            removeCookiePro();
            $(this).closest('body').find('.optanon-alert-box-wrapper, #optanon #optanon-popup-bg').css('display', 'block');
            $alertBox.css({ 'z-index':'21474836459', 'bottom': '-300px'});
            setTimeout( function() {
                $alertBox.animate({ bottom: 0 }, 'slow');
            }, 100);
        });

        $('body').on('click', '.banner-policy-link', function(e) {
            e.preventDefault();
            removeCookiePro();

            window.location = $(this).attr('href');
        });

        $('body').on('click', '.accept-cookies-button, .optanon-save-settings-button button', function(e) {
            e.preventDefault();
            Cm.cookie.setCookie('sty-cookie-clicked', 'true', 30);
        });

        // This fix the issue of cookie pro unusual behavior of not showing.
        // We checked if cookie was not yet accepted, let's clear cookie.
        if(Cm.cookie.getCookie('sty-cookie-clicked') == null) {
            removeCookiePro();
        }
    },
    removeCookiePro: function() {
        eraseCookie('OptanonAlertBoxClosed');
        eraseCookie('OptanonConsent');
        eraseCookie('intercom-id-r6ltm8ar');
        eraseCookie('__cfduid');
        eraseCookie('sty-cookie-clicked');
    },
    openCookiePro: function($) {
        $('body').find('.optanon-alert-box-wrapper, #optanon #optanon-popup-bg').css('display', 'block');
        $('body').find('.optanon-alert-box-wrapper').css({ 'z-index':'21474836459'});
    },
    getCookie: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    setCookie: function(name,value,days) {
        var day = days || 1;
        var expires = "";
        if (day) {
            var date = new Date();
            date.setTime(date.getTime() + (day*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
};